/* import __COLOCATED_TEMPLATE__ from './transactions-show-disputes-accept-modal.hbs'; */
import templateOnly from '@ember/component/template-only';
export default templateOnly();